export default "__VITE_ASSET__CnwxWjXq__"